import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { TooltipContent } from '../../../player-awards-tracker/js/components/Tooltip/TooltipContent';
import { TooltipButton } from 'common/react/components/tooltip-button';

export const RoundVotes = ({ data, rounds, seasonPid, tooltips = false }) => {
    const maxRounds =
        rounds?.filter(
            (item) => item.name.includes('Round') || item.name.includes('Week')
        ).length ?? 0;

    const seasonHasOr =
        rounds?.filter((item) => item.name.includes('Opening')).length ?? 0;

    return (
        <div className="player-awards-round-votes">
            {data &&
                [...Array(Number(maxRounds)).keys()].map((round, i) => {
                    const roundId = seasonHasOr === 0 ? round + 1 : i;
                    const roundData = data[`round${roundId}`];

                    const votes = roundData?.actual;
                    const bye = votes === 'B';
                    const notPlayed = votes === 'NP';

                    return (
                        <div
                            key={i}
                            className={classNames(
                                'player-awards-round-votes__round-container',
                                {
                                    'player-awards-round-votes__round-container--bye':
                                        bye,
                                    'player-awards-round-votes__round-container--ineligible':
                                        !bye && !data.player.eligible && votes,
                                    'player-awards-round-votes__round-container--empty':
                                        !bye && !votes,
                                    'player-awards-round-votes__round-container--not-played':
                                        votes === 'NP'
                                }
                            )}
                        >
                            {tooltips && !bye && votes ? (
                                <TooltipButton
                                    id="player-awards-player-modal-rounds-tooltip"
                                    title=""
                                    classNames={{
                                        component:
                                            'player-awards-player-modal__rounds-tooltip',
                                        button: 'player-awards-player-modal__rounds-tooltip-button'
                                    }}
                                    direction="above"
                                    primaryTooltipContent={
                                        <TooltipContent
                                            row={{}}
                                            cell={{
                                                value: votes,
                                                column: {
                                                    id: 'round' + (i + 1)
                                                }
                                            }}
                                            player={data.player.playerId}
                                            seasonPid={seasonPid}
                                        />
                                    }
                                    showOnHover={false}
                                    noPadding
                                    hideArrow
                                    externalTooltip={true}
                                >
                                    {votes}
                                </TooltipButton>
                            ) : bye ? (
                                'B'
                            ) : !notPlayed ? (
                                votes ?? ''
                            ) : (
                                ''
                            )}
                        </div>
                    );
                })}
        </div>
    );
};

RoundVotes.propTypes = {
    data: PropTypes.any.isRequired,
    rounds: PropTypes.array.isRequired,
    seasonPid: PropTypes.string.isRequired,
    tooltips: PropTypes.bool
};
